export function isValidEnumValue<T extends object>(
  theEnum: T,
  possibleValue: unknown
): possibleValue is T[keyof T] {
  return Object.values(theEnum).includes(possibleValue);
}

export function enumValueLookup<T extends { [key: string]: unknown }>(
  theEnum: T,
  value: unknown
): T[keyof T] | undefined {
  return isValidEnumValue(theEnum, value) ? value : undefined;
}
